// extracted by mini-css-extract-plugin
module.exports = {"inspect-header":"inspect-header___3Q1sf"};